import React, { useState } from "react";
import "./Components.scss";
import {
    MdCheckCircle,
    MdCancel,
    MdPending,
    MdStar,
    MdInfo,
    MdWarning,
    MdAdd,
    MdDownload,
    MdRefresh,
    MdSave,
    MdEdit,
    MdDelete,
    MdVisibility,
    MdFileCopy,
    MdShare,
    MdArchive,
} from "react-icons/md";
import Table from "../../components/common/Table/Table";
import Badge from "../../components/common/Badge/Badge";
import Button from "../../components/common/Button/Button";
import InputDropdown from "../../components/common/Inputs/InputDropdown/InputDropdown";
import AreaChartGraph from "../../components/common/Charts/AreaChartGraph";
import BarChartGraph from "../../components/common/Charts/BarChartGraph";
import SimpleLineChartGraph from "../../components/common/Charts/SimpleLineChartGraph";
import PieChartGraph from "../../components/common/Charts/PieChartGraph";
import CardCharts from "../../components/common/CardCharts/CardCharts.jsx";
import ProgressCircle from "../../components/common/ProgressCircle/ProgressCircle";

import {
    areaChartData,
    barChartData,
    lineChartData,
    pieChartData,
    usuariosData,
    zoneOptions,
    departmentOptions,
    priorityOptions,
    columnasUsuarios,
} from "./data/data.js";

const Components = () => {
    const [usuarios, setUsuarios] = useState(usuariosData);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedZone, setSelectedZone] = useState("europa");
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [selectedPriority, setSelectedPriority] = useState("medium");

    const handleEdit = (usuario) => {
        alert(`Editar: ${usuario.nombre}`);
    };

    const handleDelete = (usuario) => {
        if (window.confirm(`¿Eliminar a ${usuario.nombre}?`)) {
            setUsuarios(usuarios.filter((u) => u.id !== usuario.id));
        }
    };

    const handleView = (usuario) => {
        alert(`Ver detalle: ${usuario.nombre}`);
    };

    const handleDuplicate = (usuario) => {
        const nuevoId = Math.max(...usuarios.map((u) => u.id)) + 1;
        const usuarioDuplicado = {
            ...usuario,
            id: nuevoId,
            nombre: `${usuario.nombre} (Copia)`,
            email: usuario.email.replace("@", "+copia@"),
        };
        setUsuarios([...usuarios, usuarioDuplicado]);
        alert(`Usuario duplicado: ${usuarioDuplicado.nombre}`);
    };

    const handleShare = (usuario) => {
        alert(`Compartir información de: ${usuario.nombre}`);
    };

    const handleArchive = (usuario) => {
        alert(`Archivar usuario: ${usuario.nombre}`);
    };

    const tableMenuOptions = [
        {
            icon: <MdVisibility />,
            label: "Ver detalle",
            onClick: handleView,
            enabled: true,
        },
        {
            icon: <MdEdit />,
            label: "Editar",
            onClick: handleEdit,
            enabled: true,
        },
        {
            icon: <MdFileCopy />,
            label: "Duplicar",
            onClick: handleDuplicate,
            enabled: true,
        },
        {
            icon: <MdShare />,
            label: "Compartir",
            onClick: handleShare,
            enabled: true,
        },
        {
            icon: <MdArchive />,
            label: "Archivar",
            onClick: handleArchive,
            enabled: true,
        },
        {
            icon: <MdDelete />,
            label: "Eliminar",
            onClick: handleDelete,
            enabled: true,
        },
    ];

    const handleSave = () => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            alert("Datos guardados correctamente!");
        }, 2000);
    };

    const handleRefresh = () => {
        alert("Actualizando datos...");
    };

    return (
        <div className="components-page">
            <h1>Componentes</h1>
            <p>Preview de todos los componentes disponibles</p>

            <section className="component-section">
                <h2>Componentes de Progreso</h2>
                <p>
                    Indicadores de progreso circulares y lineales con diferentes
                    variantes
                </p>

                <div className="progress-examples">
                    <div className="progress-group">
                        <h4>Progress Circle - Básicos:</h4>
                        <div className="progress-row">
                            <ProgressCircle
                                percentage={72}
                                label="Valorización"
                                value="72,21%"
                                color="#10B981"
                            />
                            <ProgressCircle
                                percentage={88}
                                label="Eficiencia"
                                value="88,5%"
                                color="#3B82F6"
                            />
                            <ProgressCircle
                                percentage={94}
                                label="Cumplimiento"
                                value="94,2%"
                                color="#8B5CF6"
                            />
                            <ProgressCircle
                                percentage={67}
                                label="Objetivos"
                                value="67,8%"
                                color="#F59E0B"
                            />
                        </div>
                    </div>

                    <div className="progress-group">
                        <h4>Progress Circle - Tamaños:</h4>
                        <div className="progress-row">
                            <ProgressCircle
                                percentage={45}
                                label="Pequeño"
                                size={80}
                                strokeWidth={8}
                                className="progress-circle--small"
                            />
                            <ProgressCircle
                                percentage={75}
                                label="Mediano"
                                size={120}
                            />
                            <ProgressCircle
                                percentage={90}
                                label="Grande"
                                size={160}
                                strokeWidth={16}
                                className="progress-circle--large"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section className="component-section">
                <h2>Componente Button</h2>
                <p>Botones interactivos con diferentes variantes y estados</p>

                <div className="button-examples">
                    <div className="button-group">
                        <h4>Variantes principales:</h4>
                        <div className="button-row">
                            <Button variant="filled">Botón Filled</Button>
                            <Button variant="outlined">Botón Outlined</Button>
                            <Button variant="ghost">Botón Ghost</Button>
                        </div>
                    </div>

                    <div className="button-group">
                        <h4>Con iconos:</h4>
                        <div className="button-row">
                            <Button
                                variant="filled"
                                startIcon={<MdSave />}
                                onClick={handleSave}
                                loading={isLoading}
                            >
                                {isLoading ? "Guardando..." : "Guardar"}
                            </Button>
                            <Button
                                variant="outlined"
                                startIcon={<MdDownload />}
                            >
                                Descargar
                            </Button>
                            <Button
                                variant="ghost"
                                startIcon={<MdAdd />}
                                iconAlign="right"
                            >
                                Añadir
                            </Button>
                            <Button
                                variant="outlined"
                                startIcon={<MdRefresh />}
                                onClick={handleRefresh}
                            >
                                Actualizar
                            </Button>
                        </div>
                    </div>

                    <div className="button-group">
                        <h4>Icon Only:</h4>
                        <div className="button-row">
                            <Button
                                variant="filled"
                                iconOnly
                                startIcon={<MdEdit />}
                            />
                            <Button
                                variant="outlined"
                                iconOnly
                                startIcon={<MdDelete />}
                            />
                            <Button
                                variant="ghost"
                                iconOnly
                                startIcon={<MdVisibility />}
                            />
                        </div>
                    </div>

                    <div className="button-group">
                        <h4>Estados:</h4>
                        <div className="button-row">
                            <Button variant="filled">Normal</Button>
                            <Button variant="filled" disabled>
                                Deshabilitado
                            </Button>
                            <Button variant="outlined" disabled>
                                Outlined Deshabilitado
                            </Button>
                        </div>
                    </div>
                </div>
            </section>

            <section className="component-section">
                <h2>Componente InputDropdown</h2>
                <p>Selectores desplegables con diferentes opciones y estados</p>

                <div className="dropdown-examples">
                    <div className="dropdown-group">
                        <h4>Variantes básicas:</h4>
                        <div className="dropdown-row">
                            <div className="dropdown-item">
                                <label>Zona geográfica:</label>
                                <InputDropdown
                                    options={zoneOptions}
                                    value={selectedZone}
                                    onChange={setSelectedZone}
                                />
                            </div>
                            <div className="dropdown-item">
                                <label>Departamento:</label>
                                <InputDropdown
                                    options={departmentOptions}
                                    value={selectedDepartment}
                                    onChange={setSelectedDepartment}
                                    placeholder="Seleccionar departamento..."
                                />
                            </div>
                        </div>
                    </div>

                    <div className="dropdown-group">
                        <h4>Estados especiales:</h4>
                        <div className="dropdown-row">
                            <div className="dropdown-item">
                                <label>Deshabilitado:</label>
                                <InputDropdown
                                    options={zoneOptions}
                                    value="europa"
                                    disabled
                                />
                            </div>
                            <div className="dropdown-item">
                                <label>Con opciones deshabilitadas:</label>
                                <InputDropdown
                                    options={priorityOptions}
                                    value={selectedPriority}
                                    onChange={setSelectedPriority}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="component-section">
                <h2>Componente Badge</h2>
                <p>Indicadores de estado, etiquetas y elementos informativos</p>

                <div className="badge-examples">
                    <div className="badge-group">
                        <h4>Variantes disponibles:</h4>
                        <div className="badge-row">
                            <Badge variant="outlined">Outlined</Badge>
                            <Badge variant="primary">Primary</Badge>
                            <Badge variant="success">Success</Badge>
                            <Badge variant="warning">Warning</Badge>
                            <Badge variant="danger">Danger</Badge>
                            <Badge variant="info">Info</Badge>
                        </div>
                    </div>

                    <div className="badge-group">
                        <h4>Con iconos:</h4>
                        <div className="badge-row">
                            <Badge variant="success" icon={<MdCheckCircle />}>
                                Activo
                            </Badge>
                            <Badge variant="warning" icon={<MdPending />}>
                                Pendiente
                            </Badge>
                            <Badge variant="danger" icon={<MdCancel />}>
                                Inactivo
                            </Badge>
                            <Badge variant="info" icon={<MdInfo />}>
                                Información
                            </Badge>
                            <Badge
                                variant="outlined"
                                icon={<MdStar />}
                                iconPosition="right"
                            >
                                Favorito
                            </Badge>
                        </div>
                    </div>
                </div>
            </section>

            <section className="component-section">
                <h2>Componentes de Gráficos</h2>
                <p>
                    Gráficos interactivos con diferentes tipos de visualización
                    de datos
                </p>

                <div className="charts-examples">
                    <CardCharts
                        title="Ventas por Período"
                        subtitle="Evolución de ventas"
                        amount="$24,500"
                        percentage={true}
                        percentageValue={12.5}
                        percentageText="vs período anterior"
                    >
                        <AreaChartGraph data={areaChartData} />
                    </CardCharts>

                    <CardCharts
                        title="Comparativa Mensual"
                        subtitle="Datos de rendimiento"
                        amount="$18,200"
                        percentage={true}
                        percentageValue={8.3}
                        percentageText="vs mes anterior"
                    >
                        <BarChartGraph data={barChartData} />
                    </CardCharts>

                    <CardCharts
                        title="Distribución por Categoría"
                        subtitle="Porcentaje de participación"
                        amount="$31,750"
                        percentage={true}
                        percentageValue={15.7}
                        percentageText="vs período anterior"
                    >
                        <PieChartGraph data={pieChartData} />
                    </CardCharts>

                    <CardCharts
                        title="Tendencia Temporal"
                        subtitle="Análisis de evolución"
                        amount="$42,100"
                        percentage={true}
                        percentageValue={-3.2}
                        percentageText="vs período anterior"
                    >
                        <SimpleLineChartGraph data={lineChartData} />
                    </CardCharts>
                </div>
            </section>

            <section className="component-section">
                <h2>Componente Table</h2>
                <p>
                    Tabla con paginación, acciones y diferentes tipos de
                    columnas
                </p>

                <Table
                    columns={columnasUsuarios}
                    data={usuarios}
                    actions={(row, index) =>
                        tableMenuOptions.map((option) => ({
                            ...option,
                            onClick: () => option.onClick(row, index),
                        }))
                    }
                />
            </section>
        </div>
    );
};

export default Components;
